var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.items),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6","md":"4"}},[_c('Cell',{attrs:{"item":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }